import React, { Component } from 'react';
import './index.css';

class SVGLine extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }


  render() {
    // const { lang } = this.props;
    return (
      <div className='slider-ss-svg-line-cont'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2004 225.72" 
          className="slider-svg-section-streamline">
          <path d="M2,201c56,0,64-44,64-75S95,96,95,96c36,0,47,64,66,101s59,39,
            90-15.85q57.47-147.9,127.47-135.4C448.47,58.26,527.31,206,621.08,
            137S745,163.59,827.15,163.59,909.31,77.21,1009.08,137s195.25-54.72,
            209.13-79.28-28.21-24.56-17.63,0,69.5,83.28,219.5,83.28,185.45-44.63,
            219.51-100.4,84.92-47,113.49,0C1767,61,1780,181,1859,181s70-105,143-105" 
            fill="none" stroke="#f3ede6" strokeLinecap="round" strokeWidth="4"
          >
          </path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2004 225.72" 
          className="slider-svg-section-streamline">
          <path id="svg-path-section-stream-fill" d="M2,201c56,0,64-44,64-75S95,96,95
            ,96c36,0,47,64,66,101s59,39,90-15.85q57.47-147.9,127.47-135.4C448.47,
            58.26,527.31,206,621.08,137S745,163.59,827.15,163.59,
            909.31,77.21,1009.08,137s195.25-54.72,209.13-79.28-28.21-24.56-17.63,0,
            69.5,83.28,219.5,83.28,185.45-44.63,219.51-100.4,84.92-47,113.49,0C1767,
            61,1780,181,1859,181s70-105,143-105" fill="none" stroke="rgb(244, 135, 122)" 
            strokeLinecap="round" strokeWidth="4" strokeDashoffset="1850" 
            className="animate-svg-path-streamline-from-start-to-first"
          >
          </path>
        </svg>
      </div>
    );
  }
}



export default SVGLine;
